module.exports = __webpack_public_path__ + "static/media/deloitte.cdb0eb29.png";